import React from 'react';

const helpsection = () => {
  return (
    <div>
      <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <h4 className="text-sm font-semibold text-blue-900 mb-2">
          💡 Tips for a better signature:
        </h4>
        <ul className="text-xs text-blue-800 space-y-1">
          <li>• Use your mouse or touch device to sign naturally</li>
          <li>• Take your time to create a clear, readable signature</li>
          <li>• Click "Trim Signature" when you're satisfied.</li>
        </ul>
      </div>
    </div>
  );
};

export default helpsection;
